import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {commonFetchListResponse, ListResponse} from '../../../common/api-helpers';
import {CommonListFilter} from '../../../models/filters/common-list-filter';
import {AppConfigService} from '../../../services/config.service';
import {convertDexOrderTxFromApi, DexOrderTx, DexOrderTxFromApi} from './dex-order-tx';

@Injectable({providedIn: 'root'})
export class DexOrderTxStorageService {

    private readonly appConfigService = inject(AppConfigService);
    private readonly httpClient = inject(HttpClient);

    public fetchOrderTransactions(listFilter?: CommonListFilter): Observable<ListResponse<DexOrderTx>> {
        const url = this.appConfigService.api['dexOrderTransactions'];

        return commonFetchListResponse<DexOrderTxFromApi>(this.httpClient, url, listFilter).pipe(
            map(response => ({
                data:     response.data?.map(convertDexOrderTxFromApi),
                listInfo: response.listInfo
            } satisfies ListResponse<DexOrderTx>))
        );
    }

}
